module.exports = __webpack_public_path__ + "static/img/organism-h5-3.42f6dfe.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/icons/organism-h5-3.png
// module id = AUDB
// module chunks = 34